function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Worming({
  width = 19,
  height = 21,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M1 14.128c.107 2.318 1.5 4.395 3.639 5.425.267.132.562.2.861.2.887-.002 1.659-.592 1.869-1.43a1.857 1.857 0 00-.982-2.107s-1.517-.8-1.517-2.088c0-.475.694-1.15 1.363-1.8 1.75-1.185 2.692-3.208 2.454-5.269C8.447 5 7.067 3.23 5.089 2.453a1.98 1.98 0 00-1.93.102 1.863 1.863 0 00-.874 1.675c.037.67.44 1.27 1.055 1.573 0 0 1.517.8 1.517 2.088 0 .475-.694 1.15-1.363 1.8A6.318 6.318 0 001 14.128zM10 12.878c.107 2.318 1.5 4.395 3.639 5.425.267.132.562.2.861.2.887-.002 1.659-.592 1.869-1.43a1.857 1.857 0 00-.982-2.107s-1.517-.8-1.517-2.088c0-.475.694-1.15 1.363-1.8 1.75-1.185 2.692-3.208 2.453-5.269-.238-2.06-1.62-3.829-3.597-4.606a1.98 1.98 0 00-1.93.102 1.863 1.863 0 00-.874 1.675c.037.67.44 1.27 1.055 1.573 0 0 1.517.8 1.517 2.088 0 .475-.694 1.15-1.363 1.8A6.318 6.318 0 0010 12.878z",
    stroke: "#000"
  }));
}
//# sourceMappingURL=Worming.js.map